import { zodResolver } from "@hookform/resolvers/zod";
import { Box, Grid } from '@mui/material';
import { useCallback, useContext, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { ContextOperacionNuevo, ContextOperacionNuevoType } from "../../NuevoSistema";
import { OperacionAFOCLInsert } from "./types/dto";
import { OperacionAFOCLFields } from "./types/fields";
import { FormOperacionAFOCL, schemaFormOperacionAFOCL } from "./types/types";
import { HttpAFOCL } from "./api/httoAFOCL";
import { SeccionNuevoAFOCLDatosOperacion } from "./components/SeccionNuevoAFOCLDatosOperacion";
import SeccionNuevoAFOCLTablaValores from "./components/SeccionNuevoAFOCLTablaValores";
import { useSubmitOperacion } from "../../hooks/useSubmitOperacion";

interface NuevoSistemaAFOCLProps {
  codSistemaPrincipal: number
}

const NuevoSistemaAFOCL = ({ codSistemaPrincipal }: NuevoSistemaAFOCLProps) => {
  const { submitOperacion } = useSubmitOperacion();

  const formMethods = useForm<FormOperacionAFOCL>({
    resolver: zodResolver(schemaFormOperacionAFOCL),
    defaultValues: {
      [OperacionAFOCLFields.FechaSolicitud]: new Date(),
      [OperacionAFOCLFields.CodPais]: codSistemaPrincipal,
      [OperacionAFOCLFields.TablaValores]: []
    }
  })

  const handleCrearOperacion = useCallback(
    (data: OperacionAFOCLInsert) => {
      submitOperacion(data, {
        apiCall: HttpAFOCL.post,
        codSistemaPrincipal,
      });
    },
    [codSistemaPrincipal, submitOperacion]
  );

  const { setSavePromise, setSendPromise, codSistema } = useContext<ContextOperacionNuevoType>(ContextOperacionNuevo)

  useEffect(() => {
    const onSend = () => formMethods.handleSubmit(data => handleCrearOperacion(data))
    setSendPromise(onSend)
  }, [formMethods, handleCrearOperacion])

  return (
    <Box>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <SeccionNuevoAFOCLDatosOperacion formMethods={formMethods} codSistemaPrincipal={codSistemaPrincipal} codSistema={codSistema} />
        </Grid>
        <Grid item xs={12}>
          <SeccionNuevoAFOCLTablaValores formMethods={formMethods} codSistemaPrincipal={codSistemaPrincipal} />
        </Grid>
      </Grid>
    </Box>
  )
}

export default NuevoSistemaAFOCL
